import { useQuery } from "@apollo/client";

import { MetricField, ReportingGranularity, ReportingSortDirection } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { type GetOrganicStatsQuery, type GetOrganicStatsQueryVariables, getOrganicStats } from "../api/queries";
import { makeUTCStartEndTimestamp } from "../converters";
import { generateFieldsList } from "../generators";
import { GranularityInDays, type MetricsQueryParams } from "../models";

interface ChartsTotalQueryProps extends MetricsQueryParams {
    fields: MetricField[];
    dayShift?: number;
}

export const useChartsTotalQuery = ({
    lensId,
    breakdownAssetType,
    assetType,
    isAllTimeSelected,
    selectedTimeRange,
    skip = false,
    dayShift = 0,
    fields,
}: ChartsTotalQueryProps): ApolloResult<{ data: GetOrganicStatsQuery | undefined }> => {
    const { startTime, endTime } = makeUTCStartEndTimestamp(
        selectedTimeRange ? GranularityInDays[selectedTimeRange] : undefined,
        -1 * dayShift,
    );

    const { loading, error, data } = useQuery<GetOrganicStatsQuery, GetOrganicStatsQueryVariables>(getOrganicStats, {
        skip,
        variables: {
            granularity: isAllTimeSelected ? ReportingGranularity.Lifetime : ReportingGranularity.Total,
            fieldsList: generateFieldsList(fields),
            assetType,
            lensId,
            breakdownAssetType,
            startTime,
            endTime,
            sortBy: MetricField.MetricFieldUnset,
            sortDirection: ReportingSortDirection.SortDirectionUnset,
            limit: 0,
        },
    });

    return { loading, error, data };
};
